import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { CAESAR_OPCIOK } from '../caesar.opciok';

@Component({
  selector: 'app-caesar-ugyek',
  templateUrl: './ugyek.component.html',
  styleUrls: ['./ugyek.component.scss'],
})
export class UgyekComponent implements OnInit {
  @ViewChild('ugyModal') ugyModal: IonModal;
  opciok = CAESAR_OPCIOK;
  intezmeny = '';
  ugyek: any[] = [];
  ugytipusok: any[] = [];
  // Választható ügytípusok lapítva: az alkategóriák (leveles) „Fő › Al (BL)" felirattal, a
  // gyerek nélküli főkategóriák önmagukban. Az ügyazonosító a választott elem szülő+saját betűjeléből áll.
  ugytipusValaszthato() {
    const lista = this.ugytipusok || [];
    const out: any[] = [];
    for (const fo of lista.filter((t: any) => !t.szulo_id)) {
      const alk = lista.filter((t: any) => t.szulo_id === fo.id);
      if (alk.length) {
        for (const a of alk) out.push({ id: a.id, label: `${fo.nev} › ${a.nev} (${(fo.elotag || '') + (a.elotag || '')})` });
      } else {
        out.push({ id: fo.id, label: `${fo.nev}${fo.elotag ? ' (' + fo.elotag + ')' : ''}` });
      }
    }
    return out;
  }
  szemelyek: any[] = [];
  szuro = '';
  allapotSzuro = '';

  szerk: any = null;
  // az új ügyhöz felvett szereplők: [{szemely_id, nev, szerep, sajat_ugyfel}]
  ujSzereplok: any[] = [];
  szemelyValaszto = '';
  szemelyValasztott: any = null;   // a kereshetős listából kiválasztott személy
  szemelyKereso = '';              // a személyválasztó keresőmezője
  ujSzerep = 'Ügyfél';
  ujSzerepEgyeb = '';              // szabad szöveg, ha a szerepkör = Egyéb

  constructor(private http: HttpClient, private data: DataService, private router: Router, private toast: ToastController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    try {
      this.ugyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugyek/' + this.intezmeny + (this.allapotSzuro ? '?allapot=' + this.allapotSzuro : '')));
      this.ugytipusok = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugytipusok/' + this.intezmeny));
      this.szemelyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/szemelyek/' + this.intezmeny));
    } catch { this.hiba('Nem sikerült betölteni az ügyeket.'); }
  }

  get szurtUgyek() {
    const q = this.szuro.trim().toLowerCase();
    if (!q) return this.ugyek;
    return this.ugyek.filter((u) => [u.ugyazonosito, u.leiras, u.ugyfelek, u.ugytipus_nev].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)));
  }

  ujUgy() {
    this.szerk = { intezmeny: this.intezmeny, leiras: '', ugytipus_id: null, allapot: 'nyitott', megbizas_datum: new Date().toISOString().slice(0, 10) };
    this.ujSzereplok = [];
    this.szemelyValaszto = '';
    this.szemelyValasztott = null;
    this.szemelyKereso = '';
    this.ujSzerep = 'Ügyfél';
    this.ujSzerepEgyeb = '';
    this.ugyModal.present();
  }

  // Kereshetős személyválasztó: a beírt szöveg alapján szűrt törzs (max 20 találat).
  get szemelyTalalatok() {
    const q = this.szemelyKereso.trim().toLowerCase();
    if (!q) return [];
    return this.szemelyek
      .filter((s) => [s.nev, s.szuletesi_hely, s.szemelyi_szam].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)))
      .slice(0, 20);
  }
  valasztSzemely(s: any) {
    this.szemelyValasztott = s;
    this.szemelyValaszto = s.id;
    this.szemelyKereso = '';
  }

  szereploHozzaad() {
    const sz = this.szemelyValasztott;
    if (!sz) { this.hiba('Válassz személyt a keresőből.'); return; }
    if (this.ujSzereplok.some((x) => x.szemely_id === sz.id)) { this.hiba('Ez a személy már szerepel.'); return; }
    const szerep = this.ujSzerep === 'Egyéb' ? (this.ujSzerepEgyeb.trim() || 'Egyéb') : this.ujSzerep;
    this.ujSzereplok.push({ szemely_id: sz.id, nev: sz.nev, szerep, sajat_ugyfel: szerep === 'Ügyfél' });
    this.szemelyValasztott = null;
    this.szemelyValaszto = '';
    this.szemelyKereso = '';
    this.ujSzerepEgyeb = '';
  }
  szereploTorol(i: number) { this.ujSzereplok.splice(i, 1); }

  async mentes() {
    if (!this.szerk?.leiras?.trim()) return this.hiba('Az ügy megnevezése kötelező.');
    this.szerk.intezmeny = this.intezmeny;
    this.szerk.szereplok = this.ujSzereplok.map((s) => ({ szemely_id: s.szemely_id, szerep: s.szerep, sajat_ugyfel: s.sajat_ugyfel }));
    try {
      const r: any = await firstValueFrom(this.http.post('/api/caesar/ugy', this.szerk));
      await this.ugyModal.dismiss();
      this.ok('Ügy létrehozva: ' + (r?.ugyazonosito || ''));
      if (r?.id) this.megnyit(r.id);
    } catch { this.hiba('Nem sikerült létrehozni az ügyet.'); }
  }

  megnyit(id: string) { this.router.navigateByUrl('/caesar/ugy/' + id); }
  cimke(lista: any[], v: string) { return lista.find((x) => x.value === v)?.label || v || ''; }
  szin(a: string) { return { nyitott: 'primary', felfuggesztve: 'warning', lezarva: 'success' }[a] || 'medium'; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2500, color: 'danger' })).present(); }
}
